module.exports = __webpack_public_path__ + "static/media/equals.bf665f47.svg";